module.exports = __webpack_public_path__ + "static/img/jcICON6.a15412e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/data/jcICON6.png
// module id = WWVg
// module chunks = 49